import { render } from "./ProfitLossPage.vue?vue&type=template&id=d206378a&scoped=true&ts=true"
import script from "./ProfitLossPage.vue?vue&type=script&lang=ts"
export * from "./ProfitLossPage.vue?vue&type=script&lang=ts"

import "./ProfitLossPage.vue?vue&type=style&index=0&id=d206378a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d206378a"]])

export default __exports__